var _circle, _rect, _path, _path2, _rect2, _rect3, _path3, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 276,
    viewBox: "0 0 355 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 192.5,
    cy: 126.5,
    r: 126.5,
    fill: "#DEDFE4",
    fillOpacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 297.903,
    y: 126.922,
    width: 26,
    height: 26,
    transform: "rotate(-122.123 297.903 126.922)",
    fill: "#FFD1CC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M335.076 201.83C324.4 217.612 302.952 221.752 287.17 211.076L258.594 191.746L297.254 134.594L325.83 153.924C341.612 164.6 345.752 186.048 335.076 201.83V201.83Z",
    fill: "#F86969"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0815 94.9183C48.1814 90.2204 59.734 89.727 70.1976 93.5467C80.6613 97.3665 89.1791 105.186 93.8771 115.286C98.575 125.386 99.0684 136.939 95.2487 147.403C91.4289 157.866 83.6089 166.384 73.509 171.082L55.7953 133L38.0815 94.9183Z",
    fill: "#91CED2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 198.909,
    y: 155.795,
    width: 40,
    height: 40,
    transform: "rotate(49.2851 198.909 155.795)",
    fill: "#2D3E91"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 133.985,
    y: 166.701,
    width: 90,
    height: 90,
    transform: "rotate(76.435 133.985 166.701)",
    fill: "#FFD1CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M200 136.327C209.593 140.037 220.267 139.784 229.672 135.626C239.078 131.467 246.446 123.742 250.156 114.151C253.865 104.56 253.611 93.8881 249.451 84.4829C245.29 75.0777 237.564 67.7098 227.971 64L213.985 100.163L200 136.327Z",
    fill: "#FFD1CC"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 132.694,
    cy: 171.694,
    r: 20.6938,
    fill: "#F86969"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 344.5,
    cy: 133.5,
    r: 9.5,
    fill: "#2D3E91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.d9354d72900cf858db337a1723ddcd6b.svg";
export { ForwardRef as ReactComponent };